import { render, staticRenderFns } from "./TermsAndConditionContent.vue?vue&type=template&id=10172f7c&scoped=true"
import script from "./TermsAndConditionContent.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionContent.vue?vue&type=script&lang=js"
import style0 from "./TermsAndConditionContent.vue?vue&type=style&index=0&id=10172f7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10172f7c",
  null
  
)

export default component.exports